import React from "react";
import { Box, Typography } from "@mui/material";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import GuestIcon from "./GuestIcon";
import { LUXURY } from "data/guestLuxuryTheme";

const ServiceTile = ({ title, hint, illustration, onClick }) => (
  <Box
    component="button"
    type="button"
    onClick={onClick}
    sx={{
      appearance: "none",
      WebkitTapHighlightColor: "transparent",
      textAlign: "left",
      width: "100%",
      height: "100%",
      minHeight: 72,
      px: 1.2,
      py: 1.15,
      borderRadius: "16px",
      border: `1px solid ${LUXURY.cardBorder}`,
      bgcolor: LUXURY.cardSoft,
      cursor: "pointer",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 1,
      transition: "transform 0.2s ease, background 0.2s ease",
      "&:active": { transform: "scale(0.98)" },
    }}
  >
    <GuestIcon name={illustration || "stay"} size={22} variant="plain" />
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "0.82rem",
          color: LUXURY.ink,
          lineHeight: 1.25,
          wordBreak: "break-word",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          mt: 0.2,
          fontSize: "0.66rem",
          color: LUXURY.hint,
          lineHeight: 1.3,
          wordBreak: "break-word",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {hint}
      </Typography>
    </Box>
    <ChevronRightRoundedIcon sx={{ fontSize: 18, color: LUXURY.stone, flexShrink: 0 }} />
  </Box>
);

export default ServiceTile;
